import { metricKeys } from '@pulse/metrics';

export const WIDGET_TYPES = {
  dimensionTable: 'DIMENSION_TABLE',
  metric: 'METRIC',
  spi: 'SPI',
  subOpportunities: 'SUB_OPPORTUNITIES',
  audienceMetrics: 'AUDIENCE_METRICS',
};

export const DEFAULT_FILTER = {
  name: 'All Traffic',
  rule: [],
};

export const DEFAULT_DIMENSIONS = ['OBJECT_NAME', 'm3.dv.n', 'LIVE_VIDEO'];

export const METRIC_WIDGET_METRICS = [
  metricKeys.Attempts,
  metricKeys.ConcurrentPlays,
  metricKeys.EndedPlays,
  metricKeys.SpiStreams,
  metricKeys.Plays,
];

export const DISABLE_UNIT_TOGGLE_METRICS = [
  metricKeys.SpiStreams,
  metricKeys.Plays,
  metricKeys.ConcurrentPlays,
  metricKeys.StreamingPerformanceIndex,
  metricKeys.AdPlays,
];

export const OVERVIEW_AUDIENCE_METRICS = [
  metricKeys.SpiStreams,
  metricKeys.Plays,
  metricKeys.ConcurrentPlays,
  metricKeys.AdPlays,
];

// kpi dimension drodpdown metrics in order
export const KPI_DIMENSION_METRICS = [
  metricKeys.StreamingPerformanceIndex,
  metricKeys.VideoStartFailuresTechPercentage,
  metricKeys.HighExitBeforeVideoStartPercentage,
  metricKeys.HighRebufferingPercentage,
  metricKeys.HighStartupTimePercentage,
  metricKeys.VideoPlaybackFailuresTechPercentage,
  metricKeys.LowBitratePercentage,
  metricKeys.SpiStreams,
  metricKeys.Plays,
  metricKeys.ConcurrentPlays,
  metricKeys.AdPlays,
  metricKeys.BadSession,
  metricKeys.VideoStartTime,
  metricKeys.RebufferingRatio,
  metricKeys.ConnectionInducedRebufferingRatio,
  metricKeys.StreamingPerformanceIndexBest,
  metricKeys.HighExitBeforeVideoStartPercentageBest,
  metricKeys.HighRebufferingPercentageBest,
  metricKeys.HighStartupTimePercentageBest,
  metricKeys.LowBitratePercentageBest,
];

// kpi metric to dimension table columns mapping
// first metric is also the sortBy metric (DESC)
export const KPI_DIMENSIONS_MAP = {
  [metricKeys.StreamingPerformanceIndex]: [
    metricKeys.SpiStreams,
    metricKeys.StreamingPerformanceIndex,
  ],
  [metricKeys.VideoStartFailuresTechPercentage]: [
    metricKeys.Attempts,
    metricKeys.VideoStartFailuresTech,
  ],
  [metricKeys.HighExitBeforeVideoStartPercentage]: [
    metricKeys.Attempts,
    metricKeys.HighExitBeforeVideoStart,
  ],
  [metricKeys.HighRebufferingPercentage]: [metricKeys.EndedPlays, metricKeys.HighRebuffering],
  [metricKeys.HighStartupTimePercentage]: [metricKeys.Plays, metricKeys.HighStartupTime],
  [metricKeys.VideoPlaybackFailuresTechPercentage]: [
    metricKeys.EndedPlays,
    metricKeys.VideoPlaybackFailuresTech,
  ],
  [metricKeys.LowBitratePercentage]: [metricKeys.EndedPlays, metricKeys.LowBitrate],
  [metricKeys.SpiStreams]: [metricKeys.SpiStreams],
  [metricKeys.Plays]: [metricKeys.Plays],
  [metricKeys.ConcurrentPlays]: [metricKeys.ConcurrentPlays],
  [metricKeys.BadSession]: [metricKeys.SpiStreams, metricKeys.BadSession],
  [metricKeys.AdPlays]: [metricKeys.AdPlays],
  // Bitrate : Ended plays
  // VRT: Ended plays
  [metricKeys.VideoStartTime]: [metricKeys.Plays, metricKeys.VideoStartTime],
  [metricKeys.RebufferingRatio]: [metricKeys.Plays, metricKeys.RebufferingRatio],
  [metricKeys.ConnectionInducedRebufferingRatio]: [
    metricKeys.Plays,
    metricKeys.ConnectionInducedRebufferingRatio,
  ],
};

export const OPPORTUNITY_METRICS_CATEGORY = {
  STARTUP_FAIL: [
    metricKeys.VideoStartFailuresTechPercentage,
    metricKeys.HighExitBeforeVideoStartPercentage,
  ],
  PLAYBACK_ISSUES: [
    metricKeys.HighRebufferingPercentage,
    metricKeys.HighStartupTimePercentage,
    metricKeys.VideoPlaybackFailuresTechPercentage,
    metricKeys.LowBitratePercentage,
  ],
  PREROLL_STATUS_STARTUP: [
    metricKeys.VideoStartFailuresTechPercentage,
    metricKeys.VideoStartFailuresTechPercentageWithPreRoll,
    metricKeys.VideoStartFailuresTechPercentageWithoutPreRoll,
  ],
  PREROLL_STATUS_STARTUP_TIME: [
    metricKeys.HighStartupTimePercentage,
    metricKeys.HighStartupTimePercentageWithPreRoll,
    metricKeys.HighStartupTimePercentageWithoutPreRoll,
  ],
  PREROLL_STATUS_STARTUP_ABANDONMENT: [
    metricKeys.HighExitBeforeVideoStartPercentage,
    metricKeys.HighExitBeforeVideoStartPercentageWithPreRoll,
    metricKeys.HighExitBeforeVideoStartPercentageWithoutPreRoll,
  ],
  STARTUP_STATUS_BITRATE: [
    metricKeys.LowBitratePercentage,
    metricKeys.LowBitratePercentageWithAds,
    metricKeys.LowBitratePercentageWithoutAds,
  ],
  STARTUP_STATUS_REBUFFERING: [
    metricKeys.HighRebufferingPercentage,
    metricKeys.HighRebufferingPercentageWithAds,
    metricKeys.HighRebufferingPercentageWithoutAds,
  ],
  STARTUP_STATUS_PLAYBACK: [
    metricKeys.VideoPlaybackFailuresTechPercentage,
    metricKeys.VideoPlaybackFailuresTechPercentageWithAds,
    metricKeys.VideoPlaybackFailuresTechPercentageWithoutAds,
  ],
  PREROLL_STATUS_ATTEMPTS: [
    metricKeys.Attempts,
    metricKeys.AttemptsWithPreRoll,
    metricKeys.AttemptsWithoutPreRoll,
    metricKeys.AttemptsWithPreRollPct,
    metricKeys.AttemptsWithoutPreRollPct,
  ],
  STARTUP_STATUS_ENDEDPLAYS: [
    metricKeys.EndedPlays,
    metricKeys.EndedPlaysWithAds,
    metricKeys.EndedPlaysWithoutAds,
    metricKeys.EndedPlaysWithAdsPct,
    metricKeys.EndedPlaysWithoutAdsPct,
  ],
};

export const IMPROVEMENT_OPPORTUNITY_ADMETRICS = [
  ...OPPORTUNITY_METRICS_CATEGORY.PREROLL_STATUS_ATTEMPTS,
  ...OPPORTUNITY_METRICS_CATEGORY.PREROLL_STATUS_STARTUP,
  ...OPPORTUNITY_METRICS_CATEGORY.PREROLL_STATUS_STARTUP_TIME,
  ...OPPORTUNITY_METRICS_CATEGORY.PREROLL_STATUS_STARTUP_ABANDONMENT,
  ...OPPORTUNITY_METRICS_CATEGORY.STARTUP_STATUS_ENDEDPLAYS,
  ...OPPORTUNITY_METRICS_CATEGORY.STARTUP_STATUS_BITRATE,
  ...OPPORTUNITY_METRICS_CATEGORY.STARTUP_STATUS_REBUFFERING,
  ...OPPORTUNITY_METRICS_CATEGORY.STARTUP_STATUS_PLAYBACK,
];

export const SPI_BEST_METRICS = [
  metricKeys.VideoStartFailuresTechPercentage,
  metricKeys.VideoPlaybackFailuresTechPercentage,
  metricKeys.HighExitBeforeVideoStartPercentageBest,
  metricKeys.HighRebufferingPercentageBest,
  metricKeys.HighStartupTimePercentageBest,
  metricKeys.LowBitratePercentageBest,
  metricKeys.RebufferingRatio,
  metricKeys.VideoStartTime,
  metricKeys.ConnectionInducedRebufferingRatio,
];

enum VideoThresholds {
  VideoStartupTimeMilliSec = 'VideoStartupTimeMilliSec',
  SessionTimeMilliSec = 'SessionTimeMilliSec',
  PlayingTimeMilliSec = 'PlayingTimeMilliSec',
  BitrateKbps = 'BitrateKbps',
  TabletBitrateKbps = 'TabletBitrateKbps',
  TVBitrateKbps = 'TVBitrateKbps',
  ConnectionInducedRebufferingRatio = 'ConnectionInducedRebufferingRatio',
  ConnectionInducedRebufferingTimeMilliSec = 'ConnectionInducedRebufferingTimeMilliSec',
}

export const VIDEO_DEFAULT_KPI_CONFIG = {
  [VideoThresholds.VideoStartupTimeMilliSec]: 10000,
  [VideoThresholds.SessionTimeMilliSec]: 10000,
  [VideoThresholds.BitrateKbps]: 200,
  [VideoThresholds.TabletBitrateKbps]: 400,
  [VideoThresholds.TVBitrateKbps]: 800,
  [VideoThresholds.ConnectionInducedRebufferingRatio]: 0.4,
  [VideoThresholds.ConnectionInducedRebufferingTimeMilliSec]: 2000,
  kpiName: 'Conviva Good',
  kpiID: 1,
};

export const VIDEO_CREATE_NEW_SPI_CONFIG = {
  [VideoThresholds.VideoStartupTimeMilliSec]: 10000,
  [VideoThresholds.SessionTimeMilliSec]: 10000,
  [VideoThresholds.BitrateKbps]: 200,
  [VideoThresholds.TabletBitrateKbps]: 400,
  [VideoThresholds.TVBitrateKbps]: 800,
  [VideoThresholds.ConnectionInducedRebufferingRatio]: 0.4,
  [VideoThresholds.ConnectionInducedRebufferingTimeMilliSec]: 2000,
  kpiName: '',
};

export const BM_SUPPORTED_DIMENSIONS = ['GEO_COUNTRY', 'm3.dv.n', 'LIVE_VIDEO'];

export const BM_SUPPORTED_ADVANCED_DIMENSIONS = [
  'GEO_ASN',
  'GEO_CITY',
  'm3.dv.hwt',
  'm3.dv.mrk',
  'm3.dv.os',
  'm3.dv.osf',
  'm3.dv.osv',
  'GEO_STATE',
  'GEO_DMA',
  'GEO_ISP',
  'm3.dv.br',
  'm3.dv.brv',
  'm3.net.t',
];

export const BM_DIMENTIONS_MAPPING = {
  GEO_COUNTRY: 'GEO_COUNTRY',
  LIVE_VIDEO: 'c3.video.isLive',
  GEO_ASN: 'GEO_ASN',
  GEO_CITY: 'GEO_CITY',
  GEO_DMA: 'GEO_DMA',
  GEO_ISP: 'GEO_ISP',
  GEO_STATE: 'GEO_STATE',
  'm3.dv.n': 'm3.dv.n',
  'm3.dv.hwt': 'm3.dv.hwt',
  'm3.dv.mrk': 'm3.dv.mrk',
  'm3.dv.os': 'm3.dv.os',
  'm3.dv.osf': 'm3.dv.osf',
  'm3.dv.osv': 'm3.dv.osv',
  'm3.dv.br': 'm3.dv.br',
  'm3.dv.brv': 'm3.dv.brv',
  'm3.net.t': 'm3.net.t',
};

export const EIThresholdsMeta = {
  [VideoThresholds.VideoStartupTimeMilliSec]: {
    name: VideoThresholds.VideoStartupTimeMilliSec,
    displayName: 'Video Startup Time',
    short: VideoThresholds.VideoStartupTimeMilliSec,
    unit: 'ms',
    threshold: '<',
    bucket: [
      0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900,
      950, 1000, 1050, 1100, 1150, 1200, 1250, 1300, 1350, 1400, 1450, 1500, 1550, 1600, 1650, 1700,
      1750, 1800, 1850, 1900, 1950, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900,
      3000, 3250, 3500, 3750, 4000, 4250, 4500, 4750, 5000, 5500, 6000, 6500, 7000, 7500, 8000,
      8500, 9000, 9500, 10000, 12500, 15000, 17500, 20000, 25000,
    ],
  },
  [VideoThresholds.SessionTimeMilliSec]: {
    name: VideoThresholds.SessionTimeMilliSec,
    displayName: 'EBVS Wait Time',
    short: VideoThresholds.SessionTimeMilliSec,
    unit: 'ms',
    threshold: '<',
    bucket: [
      0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900,
      950, 1000, 1050, 1100, 1150, 1200, 1250, 1300, 1350, 1400, 1450, 1500, 1550, 1600, 1650, 1700,
      1750, 1800, 1850, 1900, 1950, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900,
      3000, 3250, 3500, 3750, 4000, 4250, 4500, 4750, 5000, 5500, 6000, 6500, 7000, 7500, 8000,
      8500, 9000, 9500, 10000, 12500, 15000, 17500, 20000, 25000,
    ],
  },
  [VideoThresholds.PlayingTimeMilliSec]: {
    name: VideoThresholds.PlayingTimeMilliSec,
    displayName: 'Playing Time',
    short: VideoThresholds.PlayingTimeMilliSec,
    unit: 'ms',
    threshold: '<',
    bucket: [
      0, 500, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 7500, 10000, 15000, 20000, 25000, 30000,
      35000, 40000, 45000, 50000, 55000, 60000, 70000, 80000, 90000, 100000, 110000, 120000, 150000,
      180000, 210000, 240000, 270000, 300000, 330000, 360000, 390000, 420000, 450000, 480000,
      510000, 540000, 570000, 600000, 630000, 660000, 690000, 720000, 750000, 780000, 810000,
      840000, 870000, 900000, 930000, 960000, 990000, 1020000, 1050000, 1080000, 1110000, 1140000,
      1170000, 1200000, 1230000, 1260000, 1290000, 1320000, 1350000, 1380000, 1410000, 1440000,
      1470000, 1500000, 1530000, 1560000, 1590000, 1620000, 1650000, 1680000, 1710000, 1740000,
      1770000, 1800000, 1860000, 1920000, 1980000, 2040000, 2100000, 2160000, 2220000, 2280000,
      2340000, 2400000, 2460000, 2520000, 2580000, 2640000, 2700000, 2760000, 2820000, 2880000,
      2940000, 3000000, 3060000, 3120000, 3180000, 3240000, 3300000, 3360000, 3420000, 3480000,
      3540000, 3600000, 3750000, 3900000, 4050000, 4200000, 4350000, 4500000, 4650000, 4800000,
      4950000, 5100000, 5250000, 5400000, 5700000, 6000000, 6300000, 6600000, 6900000, 7200000,
      7500000, 7800000, 8100000, 8400000, 8700000, 9000000, 9450000, 9900000, 10350000, 10800000,
      11700000, 12600000, 13500000, 14400000, 16200000, 18000000, 36000000, 2147483647,
    ],
  },
  [VideoThresholds.BitrateKbps]: {
    name: VideoThresholds.BitrateKbps,
    displayName: 'Avg Peak Bitrate on Mobile',
    short: VideoThresholds.BitrateKbps,
    unit: 'kbps',
    threshold: '>',
    bucket: [
      0, 50, 100, 125, 150, 175, 200, 225, 250, 275, 300, 350, 400, 450, 500, 550, 600, 650, 700,
      750, 800, 850, 900, 950, 1000, 1100, 1200, 1350, 1500, 1600, 1700, 1850, 2000, 2100, 2200,
      2350, 2500, 2600, 2700, 2850, 3000, 3100, 3200, 3350, 3500, 3600, 3700, 3850, 4000, 4100,
      4200, 4350, 4500, 4600, 4700, 4850, 5000, 5100, 5200, 5350, 5500, 5600, 5700, 5850, 6000,
      6250, 6500, 6750, 7000, 7250, 7500, 7750, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500,
      12000, 12500, 13000, 13500, 14000, 15000, 16000, 17000, 18000, 19000, 20000, 22500, 25000,
      27500, 30000,
    ],
  },
  [VideoThresholds.TabletBitrateKbps]: {
    name: VideoThresholds.TabletBitrateKbps,
    displayName: 'Avg Peak Bitrate on Desktop or Tablet',
    short: VideoThresholds.TabletBitrateKbps,
    unit: 'kbps',
    threshold: '>',
    bucket: [
      0, 50, 100, 125, 150, 175, 200, 225, 250, 275, 300, 350, 400, 450, 500, 550, 600, 650, 700,
      750, 800, 850, 900, 950, 1000, 1100, 1200, 1350, 1500, 1600, 1700, 1850, 2000, 2100, 2200,
      2350, 2500, 2600, 2700, 2850, 3000, 3100, 3200, 3350, 3500, 3600, 3700, 3850, 4000, 4100,
      4200, 4350, 4500, 4600, 4700, 4850, 5000, 5100, 5200, 5350, 5500, 5600, 5700, 5850, 6000,
      6250, 6500, 6750, 7000, 7250, 7500, 7750, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500,
      12000, 12500, 13000, 13500, 14000, 15000, 16000, 17000, 18000, 19000, 20000, 22500, 25000,
      27500, 30000,
    ],
  },
  [VideoThresholds.TVBitrateKbps]: {
    name: VideoThresholds.TVBitrateKbps,
    displayName: 'Avg Peak Bitrate on TV',
    short: VideoThresholds.TVBitrateKbps,
    unit: 'kbps',
    threshold: '>',
    bucket: [
      0, 50, 100, 125, 150, 175, 200, 225, 250, 275, 300, 350, 400, 450, 500, 550, 600, 650, 700,
      750, 800, 850, 900, 950, 1000, 1100, 1200, 1350, 1500, 1600, 1700, 1850, 2000, 2100, 2200,
      2350, 2500, 2600, 2700, 2850, 3000, 3100, 3200, 3350, 3500, 3600, 3700, 3850, 4000, 4100,
      4200, 4350, 4500, 4600, 4700, 4850, 5000, 5100, 5200, 5350, 5500, 5600, 5700, 5850, 6000,
      6250, 6500, 6750, 7000, 7250, 7500, 7750, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500,
      12000, 12500, 13000, 13500, 14000, 15000, 16000, 17000, 18000, 19000, 20000, 22500, 25000,
      27500, 30000,
    ],
  },
  [VideoThresholds.ConnectionInducedRebufferingRatio]: {
    name: VideoThresholds.ConnectionInducedRebufferingRatio,
    displayName: 'CIRR',
    short: VideoThresholds.ConnectionInducedRebufferingRatio,
    unit: '%',
    threshold: '<',
    bucket: [
      0.0, 0.0005, 0.001, 0.0015, 0.002, 0.003, 0.004, 0.005, 0.006, 0.007, 0.008, 0.009, 0.01,
      0.0125, 0.015, 0.0175, 0.02, 0.025, 0.03, 0.035, 0.04, 0.045, 0.05, 0.055, 0.06, 0.065, 0.07,
      0.075, 0.08, 0.085, 0.09, 0.095, 0.1, 0.11, 0.12, 0.13, 0.14, 0.15, 0.16, 0.17, 0.18, 0.19,
      0.2, 0.21, 0.22, 0.23, 0.24, 0.25, 0.26, 0.27, 0.28, 0.29, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55,
      0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9,
      2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0,
    ],
  },
  [VideoThresholds.ConnectionInducedRebufferingTimeMilliSec]: {
    name: VideoThresholds.ConnectionInducedRebufferingTimeMilliSec,
    displayName: 'CIRT',
    short: VideoThresholds.ConnectionInducedRebufferingTimeMilliSec,
    unit: 'ms',
    threshold: '<',
    bucket: [
      0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900,
      950, 1000, 1050, 1100, 1150, 1200, 1250, 1300, 1350, 1400, 1450, 1500, 1550, 1600, 1650, 1700,
      1750, 1800, 1850, 1900, 1950, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900,
      3000, 3250, 3500, 3750, 4000, 4500, 5000, 5500, 6000, 6500, 7000, 7500, 8000, 8500, 9000,
      9500, 10000, 11000, 12000, 13000, 14000, 15000, 16000, 17000, 18000, 19000, 20000, 25000,
      30000, 45000, 60000,
    ],
  },
};
